import type {
  BorderProps,
  Slide,
  TableCell,
  TextProps,
} from '@features/powerpoint';
import { generateTableV2 } from '../../../../../utils/build-table-v2';
import { contentSlideHeaderV2 } from '../../../../../utils/slide-header-v2';
import { themeV2 } from '../../../../../domain/theme-v2';
import { DEFAULT_FONT } from '../../../../../utils/constants-v2';
import type { CampaignAnalyticsSlidesV2Props } from './build-campaign-analytics-slides-v2';
import { brandLocationsRows } from '../../campaign-analytics/data-transforms';

const NO_BORDER: BorderProps = { type: 'none' };
const BOTTOM_BORDER: BorderProps = {
  type: 'solid',
  color: themeV2.colors.magnetBlue,
  pt: 1,
};
const BOTTOM_ONLY_BORDER: NonNullable<TableCell['options']>['border'] = [
  NO_BORDER,
  NO_BORDER,
  BOTTOM_BORDER,
  NO_BORDER,
];

const TABLE_HEADER_OPTIONS: TableCell['options'] = {
  bold: true,
  color: themeV2.colors.metricBlue,
  fontFace: DEFAULT_FONT,
  border: BOTTOM_ONLY_BORDER,
};

const TOP_LOCATIONS_COUNT = 20;
const VISITS_DISCLAIMER =
  'Visit Index (Average = 100) : Baseline: Observable InMarket universe';

const withNoDividers = (rows: TableCell[][]): TableCell[][] =>
  rows.map((row, rowIndex) =>
    row.map(cell => ({
      ...cell,
      options: {
        ...cell.options,
        border: rowIndex === rows.length - 1 ? NO_BORDER : BOTTOM_ONLY_BORDER,
      },
    }))
  );

const visitColumnLabels: TableCell[] = [
  { text: 'Rank', options: TABLE_HEADER_OPTIONS },
  { text: 'Name', options: TABLE_HEADER_OPTIONS },
  { text: 'Address', options: { ...TABLE_HEADER_OPTIONS, align: 'left' } },
  { text: 'City', options: TABLE_HEADER_OPTIONS },
  { text: 'State', options: TABLE_HEADER_OPTIONS },
  { text: 'Zip', options: TABLE_HEADER_OPTIONS },
  { text: 'Index', options: TABLE_HEADER_OPTIONS },
];

export const brandLocationsTableSlideV2 = (
  props: CampaignAnalyticsSlidesV2Props
): Slide => {
  const table = generateTableV2(
    visitColumnLabels,
    withNoDividers(
      brandLocationsRows(props.campaignAnalyticsReport.brandLocationVisits)
    ),
    {
      rowH: 0.1,
      w: 12,
      x: 0.33,
      y: 1.37,
      colW: [1, 1.67, 4.33, 2, 1, 1, 1],
    }
  );

  const texts: TextProps[] = [
    contentSlideHeaderV2(`Top ${TOP_LOCATIONS_COUNT} Brand Locations Visited`),
    {
      text: VISITS_DISCLAIMER,
      options: {
        x: 1.59,
        y: 7.15,
        h: 0.24,
        w: 6.67,
        fontSize: 8,
        color: themeV2.colors.metricBlue,
        fontFace: DEFAULT_FONT,
      },
    },
  ];

  return {
    slideMaster: props.slideMaster,
    tables: [table],
    texts,
  };
};
